var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar"},[_c('iframe',{attrs:{"id":"calendarIFrame","title":"GolStats","width":"100%","height":"1000","scrolling":"no","marginwidth":"0","marginheight":"0","frameborder":"0","src":_vm.calendarUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }